import React, { useEffect, useState, useCallback } from "react";
import { api } from "../api";
import { useApp } from "../context/AppContext";
import { TaskCard } from "../components/Artifacts";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useArtifactTranslations } from "../hooks/useArtifactTranslations";

export default function TasksPage() {
  const { user, t, lang } = useApp();
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const res = await api.get(`/tasks?user_id=${user.id}`);
    setTasks(res.data);
    setLoading(false);
  }, [user.id]);

  useEffect(() => { load(); }, [load]);

  // Titles/descriptions in the viewer's language (lazy, cached)
  useArtifactTranslations(tasks, setTasks, "task", lang);

  let filtered = tasks;
  if (filter === "open") filtered = tasks.filter((tk) => tk.status === "open");
  if (filter === "done") filtered = tasks.filter((tk) => tk.status === "done");

  return (
    <div className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 py-6">
      <h1 className="font-display font-bold text-2xl tracking-tight mb-4">{t("tasks")}</h1>
      <Tabs value={filter} onValueChange={setFilter} className="mb-4">
        <TabsList>
          <TabsTrigger value="all" data-testid="tasks-filter-all">{t("all")}</TabsTrigger>
          <TabsTrigger value="open" data-testid="tasks-filter-open">{t("status_open")}</TabsTrigger>
          <TabsTrigger value="done" data-testid="tasks-filter-done">{t("done")}</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="space-y-3" data-testid="tasks-list">
        {loading && [1, 2].map((i) => <div key={i} className="h-28 bg-muted rounded-xl animate-pulse" />)}
        {!loading && filtered.length === 0 && <div className="text-center text-sm text-muted-foreground py-12">{t("no_tasks")}</div>}
        {!loading && filtered.map((task) => (
          <TaskCard key={task.id} task={task} showJob onChanged={load} />
        ))}
      </div>
    </div>
  );
}
